let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dzJ0w")).then(() => parcelRequire('9u8ii'));